export class WidgetActionData {
  public component: any;
  public data: any;
  public type: any;
  constructor(component: any, data: any, type = 'default') {
    this.component = component;
    this.data = data;
    this.type = type;
  }
}
